import { render, staticRenderFns } from "./shopManageList.vue?vue&type=template&id=2813d024&scoped=true"
import script from "./shopManageList.vue?vue&type=script&lang=js"
export * from "./shopManageList.vue?vue&type=script&lang=js"
import style0 from "./shopManageList.vue?vue&type=style&index=0&id=2813d024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2813d024",
  null
  
)

export default component.exports